/* unplugin-vue-components disabled */import { render } from "./skeleton.vue?vue&type=template&id=48ee31fd&scoped=true"
import script from "./skeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./skeleton.vue?vue&type=script&setup=true&lang=js"

import "./skeleton.vue?vue&type=style&index=0&id=48ee31fd&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ee31fd"],['__file',"src/controls/skeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48ee31fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48ee31fd', __exports__)) {
    api.reload('48ee31fd', __exports__)
  }
  
  module.hot.accept("./skeleton.vue?vue&type=template&id=48ee31fd&scoped=true", () => {
    api.rerender('48ee31fd', render)
  })

}


export default __exports__